<div class="toolbar">
  <h3>Shop</h3>
  <div class="searchfield-wrapper">
    <input class="searchfield" [(ngModel)]="searchstring" placeholder="Search for a Product">
  </div>
</div>
<div class="products-info-action">
  <div class="products-count">{{ getCurrentProdsCount() }} Products
    <button class="btn btn-sm btn-warning btn-add text-white mr-0 px-2" (click)="addProduct()">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div>
<div class="content-wrapper">
  <div class="tabcontainer">
    <strong class="tabcontainer-label">Shop per category</strong>
    <div class="tab {{activecategory==null?'activetab':''}}" (click)="getProds(null)">All Products ({{allprods.length}})
    </div>
    <div *ngFor="let t of tabs" class="tab {{activecategory==t?'activetab':''}}" (click)="getProds(t)">
      {{t['display_name']}} ({{counts[t['key']] ? counts[t['key']] : '0'}})
    </div>
  </div>
  <div class="productcontainer" *ngIf="(!sub || sub.closed); else loader">
    <div *ngIf="getFilteredProducts().length==0" style="width: 100%; text-align: center; margin-top: 10px;">No items to
      display</div>
    <div class="productitem" *ngFor="let p of getFilteredProducts()">
      <div class="productimagecontainer">
        <img [src]="p.imgurl?p.imgurl:'assets/images/no_img.svg'" class="productimage">
        <div (click)="viewItem(p)" class="detailsbutton">
          View Details
        </div>
      </div>
      <div class="produxtdesccontainer">
        <span class="productname">{{p.title}}</span>
        <span class="productprice">{{p.credits}} Credits</span>
      </div>
    </div>
  </div>


  <ng-template #loader>
    <div *ngIf="sub && !sub.closed" class="text-center blink" style="width: 100%">Loading...</div>
  </ng-template>
</div>